export const brand = {
  name: "黑料社",
  slogan: "娱乐热点 · 频道导航站",
  intro:
    "黑料社是一个把娱乐八卦、网络热点与影视综动态集中起来的频道导航门户。我们不生产情绪，只整理入口——从娱乐前沿到舆情观察，从网络热梗到时尚现场，你想要的栏目都在这里。",
  email: "hello@heiliaoshe.media",
  workTime: "周一至周五 10:00 - 19:00",
};

export const channelGroups = [
  {
    id: "hot",
    title: "热点聚合",
    summary: "把当天最值得看的几条线索引到一起，先看这里再决定去哪逛。",
    icon: "ri-fire-line",
    channels: [
      {
        name: "每日热榜",
        desc: "按小时更新的全站热度排行，一眼看清大家在聊什么。",
        count: 168,
        icon: "ri-line-chart-line",
      },
      {
        name: "话题速递",
        desc: "短平快的热点速览，每条不超过三句话讲清来龙去脉。",
        count: 92,
        icon: "ri-flashlight-line",
      },
      {
        name: "舆情观察",
        desc: "追踪一个话题从发酵到平息的全过程与传播节点。",
        count: 54,
        icon: "ri-radar-line",
      },
    ],
  },
  {
    id: "ent",
    title: "娱乐前沿",
    summary: "明星动态、影视风云与音乐现场，追星追剧的日常入口。",
    icon: "ri-movie-2-line",
    channels: [
      {
        name: "明星动态",
        desc: "公开行程、新作发布与活动现场的第一手整理。",
        count: 143,
        icon: "ri-user-star-line",
      },
      {
        name: "影视风云",
        desc: "剧集电影的口碑走势、幕后花絮与阵容解析。",
        count: 126,
        icon: "ri-film-line",
      },
      {
        name: "综艺看点",
        desc: "热门综艺名场面复盘，附带弹幕梗的出处考据。",
        count: 88,
        icon: "ri-mic-2-line",
      },
      {
        name: "音乐现场",
        desc: "新歌、巡演与榜单变化，现场返图与舞台风格盘点。",
        count: 71,
        icon: "ri-music-2-line",
      },
    ],
  },
  {
    id: "net",
    title: "网络文化",
    summary: "从热梗到二创，理解年轻人在互联网上到底在乐什么。",
    icon: "ri-global-line",
    channels: [
      {
        name: "网络热梗",
        desc: "全网新梗的源头考据，顺带一份使用说明书。",
        count: 117,
        icon: "ri-emotion-laugh-line",
      },
      {
        name: "二创浪潮",
        desc: "短视频与图文二创的玩法观察，以及版权边界讨论。",
        count: 63,
        icon: "ri-scissors-cut-line",
      },
      {
        name: "社群生态",
        desc: "应援文化、粉丝社群与线上活动组织方式观察。",
        count: 45,
        icon: "ri-group-line",
      },
    ],
  },
  {
    id: "life",
    title: "生活方式",
    summary: "把镜头从屏幕上挪开，看看红毯之外的审美与日常。",
    icon: "ri-palette-line",
    channels: [
      {
        name: "时尚穿搭",
        desc: "红毯造型与街拍风格观察，极简与繁复的两极审美。",
        count: 79,
        icon: "ri-shirt-line",
      },
      {
        name: "城市夜话",
        desc: "线下活动、音乐节与探店现场的氛围记录。",
        count: 52,
        icon: "ri-building-4-line",
      },
      {
        name: "影像随笔",
        desc: "用影像与短评记录值得被反复回看的片段。",
        count: 38,
        icon: "ri-camera-lens-line",
      },
    ],
  },
];

export const channels = channelGroups.flatMap((group) =>
  group.channels.map((channel) => ({
    ...channel,
    group: group.title,
    groupId: group.id,
  })),
);

export const stats = [
  { label: "频道分区", value: "12", suffix: "个" },
  { label: "收录专题", value: "320", suffix: "篇" },
  { label: "日均更新", value: "80", suffix: "条" },
  { label: "覆盖领域", value: "9", suffix: "类" },
];

export const trending = [
  {
    id: "t1",
    tag: "综艺看点",
    title: "本周综艺名场面盘点：那些被反复回看的五秒钟",
    excerpt:
      "有些片段只有五秒，却能被剪成几十个版本反复传播。我们拆解了本周最出圈的六个瞬间，看看它们为什么好笑。",
    meta: "1.2 万次阅读 · 3 小时前",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20editorial%20abstract%20scene%20of%20a%20bright%20studio%20stage%20spotlight%20with%20crimson%20and%20gold%20light%20beams%20on%20deep%20charcoal%20background%2C%20minimal%20geometric%20shapes%2C%20cinematic%20soft%20glow%2C%20no%20text%2C%20high%20detail%2C%20harmonious%20composition&width=800&height=600&seq=hl-trend-01&orientation=landscape",
  },
  {
    id: "t2",
    tag: "影视风云",
    title: "新剧集中上线，观众为何越来越偏爱群像叙事",
    excerpt:
      "单主角的故事正在让位给多线索并行的群像结构。这种变化背后，是观众对真实感与讨论空间的更高要求。",
    meta: "9800 次阅读 · 6 小时前",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20editorial%20abstract%20scene%20of%20overlapping%20film%20frames%20and%20light%20stripes%20in%20crimson%20amber%20and%20moss%20tones%20on%20warm%20cream%20background%2C%20minimal%20modern%20graphic%20style%2C%20no%20text%2C%20high%20detail%2C%20balanced%20composition&width=800&height=600&seq=hl-trend-02&orientation=landscape",
  },
  {
    id: "t3",
    tag: "网络热梗",
    title: "从热搜到长尾：一个网络热梗的完整生命周期",
    excerpt:
      "热梗也有生老病死。我们追踪了三个典型热梗的传播曲线，试图回答一个问题：它到底能活多久？",
    meta: "1.5 万次阅读 · 今天",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20editorial%20abstract%20illustration%20of%20a%20rising%20wave%20curve%20with%20glowing%20nodes%20in%20crimson%20and%20gold%20on%20deep%20charcoal%2C%20minimal%20data%20visual%20aesthetic%2C%20soft%20glow%2C%20no%20text%2C%20high%20detail%2C%20clean%20composition&width=800&height=600&seq=hl-trend-03&orientation=landscape",
  },
  {
    id: "t4",
    tag: "时尚穿搭",
    title: "红毯造型风格观察：极简与繁复的两极审美",
    excerpt:
      "一边是几乎无装饰的素色长裙，一边是层层叠叠的重工礼服。今年的红毯，把两条审美路线推到了极致。",
    meta: "7600 次阅读 · 昨天",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20editorial%20abstract%20fashion%20concept%20with%20flowing%20fabric%20ribbons%20in%20ochre%20crimson%20and%20cream%20tones%20on%20soft%20neutral%20background%2C%20minimal%20elegant%20graphic%20style%2C%20soft%20light%2C%20no%20text%2C%20high%20detail%2C%20balanced%20composition&width=800&height=600&seq=hl-trend-04&orientation=landscape",
  },
  {
    id: "t5",
    tag: "音乐现场",
    title: "音乐节现场返图刷屏，年轻人在追什么样的现场",
    excerpt:
      "比舞台更出圈的是观众席。从灯牌到合唱，我们整理了今年音乐节现场最受欢迎的几种参与方式。",
    meta: "6300 次阅读 · 昨天",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20editorial%20abstract%20concert%20crowd%20silhouettes%20with%20warm%20amber%20and%20crimson%20stage%20light%20haze%20on%20dark%20background%2C%20minimal%20cinematic%20poster%20style%2C%20glowing%20atmosphere%2C%20no%20text%2C%20high%20detail%2C%20layered%20composition&width=800&height=600&seq=hl-trend-05&orientation=landscape",
  },
  {
    id: "t6",
    tag: "二创浪潮",
    title: "短视频二创浪潮下，内容版权的边界在哪里",
    excerpt:
      "二创让原作二次走红，也带来了新的争议。梳理目前常见的几种授权与合作模式，或许能找到共赢的答案。",
    meta: "5400 次阅读 · 2 天前",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20editorial%20abstract%20geometric%20collage%20of%20interlocking%20shapes%20in%20moss%20green%20crimson%20and%20cream%20on%20warm%20neutral%20background%2C%20minimal%20modern%20graphic%20design%2C%20no%20text%2C%20high%20detail%2C%20balanced%20composition&width=800&height=600&seq=hl-trend-06&orientation=landscape",
  },
];

export const rankings = {
  week: [
    { rank: 1, title: "某综艺名场面剪辑破百万播放", group: "综艺看点", heat: "98.6 万", delta: "up" },
    { rank: 2, title: "新剧开播首日讨论度冲上首位", group: "影视风云", heat: "87.2 万", delta: "up" },
    { rank: 3, title: "红毯造型对比图引发审美讨论", group: "时尚穿搭", heat: "76.4 万", delta: "down" },
    { rank: 4, title: "全新热梗三天内席卷评论区", group: "网络热梗", heat: "69.1 万", delta: "up" },
    { rank: 5, title: "音乐节现场返图合集持续刷屏", group: "音乐现场", heat: "58.7 万", delta: "same" },
    { rank: 6, title: "影视幕后花絮公开引观众热议", group: "影视风云", heat: "51.3 万", delta: "up" },
    { rank: 7, title: "应援活动组织方式被广泛讨论", group: "社群生态", heat: "44.8 万", delta: "down" },
    { rank: 8, title: "城市探店影像记录走红社交平台", group: "城市夜话", heat: "37.5 万", delta: "up" },
  ],
  month: [
    { rank: 1, title: "年度口碑剧集榜单持续霸榜", group: "影视风云", heat: "426 万", delta: "up" },
    { rank: 2, title: "现象级热梗衍生二创作品破万", group: "网络热梗", heat: "388 万", delta: "up" },
    { rank: 3, title: "夏季音乐节话题累计阅读破亿", group: "音乐现场", heat: "351 万", delta: "same" },
    { rank: 4, title: "红毯造型风格年度大盘点", group: "时尚穿搭", heat: "312 万", delta: "up" },
    { rank: 5, title: "群像叙事剧集成为主流创作方向", group: "影视风云", heat: "287 万", delta: "down" },
    { rank: 6, title: "粉丝社群线上活动形式多样化", group: "社群生态", heat: "243 万", delta: "up" },
    { rank: 7, title: "短视频二创版权合作模式探索", group: "二创浪潮", heat: "206 万", delta: "up" },
    { rank: 8, title: "综艺解压类内容需求明显上升", group: "综艺看点", heat: "181 万", delta: "down" },
  ],
};

export const sitemapGroups = [
  {
    title: "内容频道",
    links: [
      { label: "每日热榜", href: "#ranking" },
      { label: "话题速递", href: "#trending" },
      { label: "明星动态", href: "#channels" },
      { label: "影视风云", href: "#channels" },
      { label: "综艺看点", href: "#channels" },
      { label: "音乐现场", href: "#channels" },
    ],
  },
  {
    title: "网络文化",
    links: [
      { label: "网络热梗", href: "#channels" },
      { label: "二创浪潮", href: "#channels" },
      { label: "社群生态", href: "#channels" },
      { label: "舆情观察", href: "#channels" },
      { label: "影像随笔", href: "#channels" },
      { label: "城市夜话", href: "#channels" },
    ],
  },
  {
    title: "服务与帮助",
    links: [
      { label: "站点地图", href: "#sitemap" },
      { label: "常见问题", href: "#faq" },
      { label: "内容原则", href: "#about" },
      { label: "意见反馈", href: "#contact" },
      { label: "订阅更新", href: "#contact" },
      { label: "联系我们", href: "#contact" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "品牌介绍", href: "#about" },
      { label: "网站定位", href: "#about" },
      { label: "用户口碑", href: "#about" },
      { label: "联系方式", href: "#contact" },
      { label: "更新日志", href: "#about" },
      { label: "免责声明", href: "#about" },
    ],
  },
];

export const faqs = [
  {
    q: "黑料社是做什么的？",
    a: "黑料社是一个娱乐热点频道导航门户。我们把分散的栏目与专题整理成清晰的频道分区和站点地图，让用户几秒内就能定位到自己感兴趣的内容入口。",
  },
  {
    q: "如何在网站里快速找到我想看的栏目？",
    a: "首屏的搜索框支持按频道名称和主题关键词筛选；也可以直接使用顶部导航的锚点，或下滑到「站点地图」查看全部栏目的完整清单。",
  },
  {
    q: "网站内容多久更新一次？",
    a: "热榜与话题速递按小时滚动更新，热门推荐与专题内容每日更新，频道结构则会根据用户的查找习惯定期调整，目前日均更新约 80 条。",
  },
  {
    q: "内容来源与筛选标准是什么？",
    a: "我们只整理已在公开渠道广泛讨论的娱乐与热点信息，并优先呈现事件脉络而非单一情绪表达。对于无法核实的说法，会明确标注为待确认。",
  },
  {
    q: "可以投稿或推荐话题吗？",
    a: "可以。你可以通过页脚的邮箱把线索发给我们，或在订阅表单里留下联系方式。我们会在核实后决定是否收录，并尽可能回复每一条来信。",
  },
  {
    q: "网站会保存我的个人信息吗？",
    a: "不会。本站为纯展示型门户，只有在订阅或反馈时你主动填写的邮箱会被保存，仅用于回信与更新提醒，不会用于其它用途。",
  },
];

export const testimonials = [
  {
    name: "林一然",
    role: "重度追剧用户",
    text: "以前找某部剧的幕后花絮要翻半天，现在从频道导览两步就能点到，站点地图做得特别清楚。",
  },
  {
    name: "周小满",
    role: "社群运营",
    text: "舆情观察这个栏目帮我省了很多整理时间，脉络梳理得有条理，不堆砌情绪，适合直接当参考。",
  },
  {
    name: "陈默",
    role: "内容创作者",
    text: "热梗考据做得挺认真，会标注出处和传播路径，对我做选题很有帮助，界面也很干净。",
  },
];

export const navLinks = [
  { label: "首页", href: "#home" },
  { label: "频道导览", href: "#channels" },
  { label: "热门推荐", href: "#trending" },
  { label: "热度榜", href: "#ranking" },
  { label: "站点地图", href: "#sitemap" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];